import { render } from "./personnel_workbench.vue?vue&type=template&id=9359e818&scoped=true"
import script from "./personnel_workbench.vue?vue&type=script&lang=js"
export * from "./personnel_workbench.vue?vue&type=script&lang=js"

import "./personnel_workbench.vue?vue&type=style&index=0&id=9359e818&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9359e818"]])

export default __exports__